import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import {observer} from 'mobx-react'
import {Alert, Button, Card, Checkbox} from 'antd'

import {PaypalSvg} from '~/assets/icons'

import {PayPalOnboardingProps} from './props'
import styles from './PaypalOnboarding.scss'
import { PAYPAL_ENABLE, SETUP_PAYPAL_ACCOUNT } from '@/constants/playwright-ids'

export const PayPalOnboarding: React.FC<PayPalOnboardingProps> = observer(
    ({actionUrl, isPoliciesAccepted, setPoliciesAccepted}) => {
    const { t } = useTranslation()
        return actionUrl ? (
            <>
                <br />
                <Card>
                    <Checkbox
                        value={isPoliciesAccepted}
                        className={styles.checkbox}
                        onChange={e => setPoliciesAccepted(e.target.checked)}
                        data-test-id={PAYPAL_ENABLE}
                    >
                        {t('PaypalOnboarding.acceptPolicies')}
                    </Checkbox>
                    <br />
                    <Button
                        className={classNames(styles.payPalButton, {
                            [styles.payPalButtonDisabled]: !isPoliciesAccepted
                        })}
                        data-paypal-button='true'
                        disabled={!isPoliciesAccepted}
                        target='PPFrame'
                        href={`${actionUrl}&displayMode=minibrowser`}
                        type='primary'
                        icon={<PaypalSvg />}
                        data-test-id={SETUP_PAYPAL_ACCOUNT}
                    >
                        {t('PaypalOnboarding.setUpPayPalAccount')}
                    </Button>
                </Card>
                <br />
                <Alert message={t('PaypalOnboarding.warningMessage')} type='warning' showIcon />
                <br />
            </>
        ) : null
    }
)
